
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.719 4.8a3.2 3.2 0 110 6.4 3.2 3.2 0 010-6.4zm0 1.6a1.6 1.6 0 100 3.2 1.6 1.6 0 000-3.2zm-1.6 9.6a.404.404 0 01-.4-.336l-.296-2.12a5.556 5.556 0 01-1.352-.792l-1.992.808a.402.402 0 01-.488-.176l-1.6-2.768a.394.394 0 01.096-.512l1.688-1.328L2.719 8l.056-.8-1.688-1.304a.394.394 0 01-.096-.512l1.6-2.768c.096-.176.312-.248.488-.176l1.992.8a5.799 5.799 0 011.352-.784l.296-2.12a.404.404 0 01.4-.336h3.2c.2 0 .368.144.4.336l.296 2.12c.504.2.936.472 1.352.784l1.992-.8a.393.393 0 01.488.176l1.6 2.768a.394.394 0 01-.096.512L14.663 7.2l.056.8-.056.8 1.688 1.304c.152.12.2.336.096.512l-1.6 2.768a.393.393 0 01-.488.176l-1.992-.8a5.799 5.799 0 01-1.352.784l-.296 2.12a.404.404 0 01-.4.336h-3.2zm1-14.4l-.296 2.088c-.96.2-1.808.712-2.424 1.424L3.47 4.28l-.6 1.04 1.688 1.24a4.44 4.44 0 000 2.88l-1.696 1.248.6 1.04 1.944-.832a4.355 4.355 0 002.408 1.408L8.11 14.4h1.216l.296-2.088a4.414 4.414 0 002.408-1.416l1.944.832.6-1.04-1.696-1.24c.32-.936.32-1.952 0-2.888l1.688-1.24-.6-1.04-1.928.832a4.336 4.336 0 00-2.424-1.416L9.319 1.6h-1.2z","fill":"currentColor"}})])
          )
        }
      }
    